import {Exclude, Expose} from 'class-transformer';
import {AbstractApiModel} from './abstract.api.model';

@Exclude()
export class ProjectVehicleParametersOverrideApiModel extends AbstractApiModel {
  @Expose() public id: number;
  @Expose() public project: string;

  @Expose() public powerHp: number | null;
  @Expose() public torqueNm: number | null;
  @Expose() public maxPowerRpm: number | null;
  @Expose() public maxTorqueRpm: number | null;
  @Expose() public accelerationZeroToHundred: number | null;
  @Expose() public topSpeed: number | null;
  @Expose() public engineDisplacement: number | null;
  @Expose() public weight: number | null;
  @Expose() public cylinders: number | null;
  @Expose() public valvesPerCylinder: number | null;
  @Expose() public cylinderBore: number | null;
  @Expose() public strokeCycle: number | null;
  @Expose() public redlineRpm: number | null;
  @Expose() public turningCircleM: number | null;
  @Expose() public cityFuelConsumption: number | null;
  @Expose() public highwayFuelConsumption: number | null;
  @Expose() public mixedFuelConsumption: number | null;
  @Expose() public fuelTank: number | null;
  @Expose() public length: number | null;
  @Expose() public height: number | null;
  @Expose() public width: number | null;
  @Expose() public fullWeight: number | null;
  @Expose() public groundClearance: number | null;
  @Expose() public frontTrack: number | null;
  @Expose() public rearTrack: number | null;
  @Expose() public wheelbase: number | null;
  @Expose() public numberOfSeats: number | null;
  @Expose() public payload: number | null;
  @Expose() public minTrunkCapacity: number | null;
  @Expose() public maxTrunkCapacity: number | null;

  @Expose() public forcedInductionDescriptionOverride: string | null;
  @Expose() public intercoolerDescriptionOverride: string | null;
  @Expose() public suspensionDescriptionOverride: string | null;
  @Expose() public brakesDescriptionOverride: string | null;
  @Expose() public frontSuspensionDescriptionOverride: string | null;
  @Expose() public rearSuspensionDescriptionOverride: string | null;
  @Expose() public frontBrakesDescriptionOverride: string | null;
  @Expose() public rearBrakesDescriptionOverride: string | null;
  @Expose() public intakeDescriptionOverride: string | null;
  @Expose() public exhaustDescriptionOverride: string | null;
  @Expose() public coolingDescriptionOverride: string | null;
  @Expose() public gearboxDescriptionOverride: string | null;
  @Expose() public fuelSystemDescriptionOverride: string | null;
  @Expose() public cruisingRangeDescriptionOverride: string | null;
  @Expose() public emissionDescriptionOverride: string | null;
  @Expose() public cylinderLayoutDescriptionOverride: string | null;
  @Expose() public fuelTypeDescriptionOverride: string | null;
  @Expose() public fuelGradeDescriptionOverride: string | null;
  @Expose() public numberOfGearsDescriptionOverride: string | null;
  @Expose() public injectionTypeDescriptionOverride: string | null;
  @Expose() public bodyTypeDescriptionOverride: string | null;
  @Expose() public wheelsTiresDescriptionOverride: string | null;

  @Expose() public forcedInductionUpgradeDescription: string | null;
  @Expose() public intercoolerUpgradeDescription: string | null;
  @Expose() public suspensionUpgradeDescription: string | null;
  @Expose() public brakesUpgradeDescription: string | null;
  @Expose() public frontSuspensionUpgradeDescription: string | null;
  @Expose() public rearSuspensionUpgradeDescription: string | null;
  @Expose() public frontBrakesUpgradeDescription: string | null;
  @Expose() public rearBrakesUpgradeDescription: string | null;
  @Expose() public intakeUpgradeDescription: string | null;
  @Expose() public exhaustUpgradeDescription: string | null;
  @Expose() public coolingUpgradeDescription: string | null;
  @Expose() public gearboxUpgradeDescription: string | null;
  @Expose() public fuelSystemUpgradeDescription: string | null;
  @Expose() public cruisingRangeUpgradeDescription: string | null;
  @Expose() public emissionUpgradeDescription: string | null;
  @Expose() public cylinderLayoutUpgradeDescription: string | null;
  @Expose() public fuelTypeUpgradeDescription: string | null;
  @Expose() public fuelGradeUpgradeDescription: string | null;
  @Expose() public numberOfGearsUpgradeDescription: string | null;
  @Expose() public injectionTypeUpgradeDescription: string | null;
  @Expose() public bodyTypeUpgradeDescription: string | null;
  @Expose() public wheelsTiresUpgradeDescription: string | null;
}
